import React from "react";
import Index from "../views/dashboard/index";
// import { Switch, Route } from 'react-router-dom'

// Dashboard Detail
import DashPrimer from "../views/dashboard/dashprimer";
import DashPasca from "../views/dashboard/dashpasca";
import DashEkspor from "../views/dashboard/dashekspor";

//admin
import Default from "../layouts/dashboard/default";

//ekspor
import Draft from "../views/permohonan/ekspor/Draft";
import OnProcess from "../views/permohonan/ekspor/OnProcess";
import SiapApprove from "../views/permohonan/ekspor/SiapApprove";
import Disetujui from "../views/permohonan/ekspor/Disetujui";
import Ditolak from "../views/permohonan/ekspor/Ditolak";
import Daftar from "../views/penugasan/Daftar";
import DaftarSelesai from "../views/penugasan/DaftarSelesai";
import ViewEditEkspor2 from "../views/permohonan/ekspor/ViewEditEkspor2";

//impor
import DraftImpor from "../views/permohonan/impor/Draft";
import OnProcessImpor from "../views/permohonan/impor/OnProcess";
import DisetujuiImpor from "../views/permohonan/impor/Disetujui";
import RealisasiPostBorder from "../views/permohonan/impor/RealisasiPostBorder";

//master
import MasterIkan from "../views/master/MasterIkan";
import MasterIkanSatuan from "../views/master/MasterIkanSatuan";
import Kemasan from "../views/master/Kemasan";
import Bentuk from "../views/master/Bentuk";
import Disposisi from "../views/master/Disposisi";
import HasilUji from "../views/master/HasilUji";
import JenisHcm from "../views/master/JenisHcm";
import JenisKegiatan from "../views/master/JenisKegiatan";
import JenisUji from "../views/master/JenisUji";
import Kecamatan from "../views/master/Kecamatan";
import Kesimpulan from "../views/master/Kesimpulan";
import MasterHs from "../views/master/Hs";
import MetodeLab from "../views/master/MetodeLab";
import Negara from "../views/master/Negara";
import Pelabuhan from "../views/master/Pelabuhan";
import TarifPnbp from "../views/master/TarifPnbp";
import PelabuhanPendaratan from "../views/master/PelabuhanPendaratan";

//setting
import Pengguna from "../views/setting/Pengguna";
import RolePengguna from "../views/setting/RolePengguna";
import Upt from "../views/setting/Unit";
// import Trader from "../views/setting/Trader";
import Traders from "../views/setting/Traders";
// import EditTRader from "../views/setting/edit-trader";
import EditTRader from "../views/setting/edit-trader/index";
import EditPegawai from "../views/setting/edit-pegawai";
import Partner from "../views/setting/Partner";
import Upi from "../views/setting/Upi";
import Login from "../views/dashboard/auth/sign-in";
import SignUp from "../views/dashboard/auth/sign-up";
import Registrasi from "../views/registrasi/index";

// Ingat ini hanya template
// import Registrasi2 from "../views/registrasi/registrasi";

import Profile from "../views/setting/traderProfile";
import DataPegawai from '../views/setting/DataPegawai';
import UserTrader from '../views/setting/UserTrader';

import ResetPassword from '../views/dashboard/Password/resetpassword';

import ActivatePassphrase from '../views/dashboard/Passphrase/activatePassphrase';
// Supplier
import SupplierPage from "../views/setting/Supplier";
import EditUpiSupplier from "../views/setting/EditSupplier";

// statistik
import Statistik from "../views/statistik/index";

//pbumku
import DaftarPrimer from "../views/pbumku/primer/DaftarPrimer";
import DokChecklist from "../views/pbumku/primer/DokChecklist";
import UpiAddEdit from "../views/setting/UpiAddEdit";
import PartnerAddEdit from "../views/setting/PartnerAddEdit";
import MasterIkanAddEdit from "../views/master/MasterIkanAddEdit";
import TraderAlamat from "../views/setting/TraderAlamat";
import TraderAlamatAddEdit from "../views/setting/TraderAlamatAddEdit";
import DaftarEvAdmin from "../views/penugasan/DaftarEvAdmin";
import DaftarProses from "../views/penugasan/DaftarProses";
import DaftarEvTeknis from "../views/penugasan/DaftarEvTeknis";
import DaftarTerbitDraft from "../views/penugasan/DaftarTerbitDraft";
import DaftarSetujuDraft from "../views/penugasan/DaftarSetujuDraft";
import DaftarPnbpNull from "../views/penugasan/DaftarPnbpNull";

//view smkhp
import QRCode from "../views/viewsmkhp/QRCode";
import FormH from "../views/viewsmkhp/formH";

// report
import ReportSMKHP from "../views/report/ReportSMKHP";
import ReportUMKU from "../views/report/ReportPBUMKU";
import ReportPasca from "../views/report/ReportPascaPanen"

// nonlalin
import DraftNonLalin from "../views/nonlalin/permohonan/DraftNonLalin";
import DaftarMasuk from "../views/nonlalin/penugasan/DaftarMasuk";
import ViewEditNonLalin from "../views/nonlalin/permohonan/ViewEditNonLalin";
import OnProcessNonLalin from "../views/nonlalin/permohonan/OnProcessNonLalin";
import DaftarLab from "../views/nonlalin/penugasan/DaftarLab";
import DaftarJasaLainnya from "../views/nonlalin/penugasan/DaftarJasaLainnya";
import DaftarScanning from "../views/nonlalin/penugasan/DaftarScanning";

//kapal
import DraftKapal from "../views/pbumku/kapal/permohonan/DraftKapal";
import MasterKapal from "../views/pbumku/kapal/master/MasterKapal";
import ViewEditKapal from "../views/pbumku/kapal/permohonan/ViewEditKapal";
import EvpKapal from "../views/pbumku/kapal/penugasan/EvpKapal";
import InspeksiKapal from "../views/pbumku/kapal/penugasan/InspeksiKapal";
import OnProcessKapal from "../views/pbumku/kapal/permohonan/OnProcessKapal";
import TerbitKapal from "../views/pbumku/kapal/permohonan/TerbitKapal";
import TolakKapal from "../views/pbumku/kapal/permohonan/TolakKapal";
import EvtKapal from "../views/pbumku/kapal/penugasan/EvtKapal";

//billing
import DaftarBilling from "../views/billing/Daftar";
import DaftarPnbp from "../views/billing/DaftarPnbp";

import EditPnbp from "../views/setting/EditPnbp";

// import SertCBIBView from "../views/cetak/primer/SertCBIB";
import DraftNonLalinUPT from "../views/nonlalin/permohonan/DraftNonLalinUPT";
import DaftarCpib from "../views/pbumku/cpib/permohonan/DaftarCpib";
import DaftarCbib from "../views/pbumku/cbib/permohonan/DaftarCbib";
import DaftarCppib from "../views/pbumku/cppib/permohonan/DaftarCppib";
import DaftarCpoib from "../views/pbumku/cpoib/permohonan/DaftarCpoib";
import DaftarCdoib from "../views/pbumku/cdoib/permohonan/DaftarCdoib";
import DaftarCpibManual from "../views/pbumku/cpib/permohonan/DaftarCpibManual";
import DaftarCbibManual from "../views/pbumku/cbib/permohonan/DaftarCbibManual";
import InspeksiCpib from "../views/pbumku/cpib/penugasan/InspeksiCpib";
import VerifikasiDokCpib from "../views/pbumku/cpib/penugasan/VerifikasiDokCpib";
import ReviuRekomCpib from "../views/pbumku/cpib/penugasan/ReviuRekomCpib";
import VerifikasiDokCbib from "../views/pbumku/cbib/penugasan/VerifikasiDokCbib";
import InspeksiCbib from "../views/pbumku/cbib/penugasan/InspeksiCbib";
import ReviuRekomCbib from "../views/pbumku/cbib/penugasan/ReviuRekomCbib";
import InspeksiCppib from "../views/pbumku/cppib/penugasan/InspeksiCppib";
import ReviuRekomCppib from "../views/pbumku/cppib/penugasan/ReviuRekomCppib";
import InspeksiCpoib from "../views/pbumku/cpoib/penugasan/InspeksiCpoib";
import ReviuRekomCpoib from "../views/pbumku/cpoib/penugasan/ReviuRekomCpoib";
import InspeksiCdoib from "../views/pbumku/cdoib/penugasan/InspeksiCdoib";
import ReviuRekomCdoib from "../views/pbumku/cdoib/penugasan/ReviuRekomCdoib";
import ApprovalCpib from "../views/pbumku/cpib/penugasan/ApprovalCpib";
import TerbitCpib from "../views/pbumku/cpib/penugasan/TerbitCpib";
import TolakCpib from "../views/pbumku/cpib/penugasan/TolakCpib";
import ApprovalCbib from "../views/pbumku/cbib/penugasan/ApprovalCbib";
import TerbitCbib from "../views/pbumku/cbib/penugasan/TerbitCbib";
import TolakCbib from "../views/pbumku/cbib/penugasan/TolakCbib";
import ApprovalCppib from "../views/pbumku/cppib/penugasan/ApprovalCppib";
import TerbitCppib from "../views/pbumku/cppib/penugasan/TerbitCppib";
import TolakCppib from "../views/pbumku/cppib/penugasan/TolakCppib";
import ApprovalCpoib from "../views/pbumku/cpoib/penugasan/ApprovalCpoib";
import TerbitCpoib from "../views/pbumku/cpoib/penugasan/TerbitCpoib";
import TolakCpoib from "../views/pbumku/cpoib/penugasan/TolakCpoib";
import ApprovalCdoib from "../views/pbumku/cdoib/penugasan/ApprovalCdoib";
import TerbitCdoib from "../views/pbumku/cdoib/penugasan/TerbitCdoib";
import TolakCdoib from "../views/pbumku/cdoib/penugasan/TolakCdoib";
import DaftarSpdi from "../views/pbumku/spdi/permohonan/DaftarSpdi";
import InspeksiSpdi from "../views/pbumku/spdi/penugasan/InspeksiSpdi";
import ReviuRekomSpdi from "../views/pbumku/spdi/penugasan/ReviuRekomSpdi";
import ApprovalSpdi from "../views/pbumku/spdi/penugasan/ApprovalSpdi";
import TerbitSpdi from "../views/pbumku/spdi/penugasan/TerbitSpdi";
import TolakSpdi from "../views/pbumku/spdi/penugasan/TolakSpdi";
import DaftarCpibk from "../views/pbumku/cpibk/permohonan/DaftarCpibk";
import InspeksiCpibk from "../views/pbumku/cpibk/penugasan/InspeksiCpibk";
import ReviuRekomCpibk from "../views/pbumku/cpibk/penugasan/ReviuRekomCpibk";
import ApprovalCpibk from "../views/pbumku/cpibk/penugasan/ApprovalCpibk";
import TerbitCpibk from "../views/pbumku/cpibk/penugasan/TerbitCpibk";
import TolakCpibk from "../views/pbumku/cpibk/penugasan/TolakCpibk";
import DaftarSkp from "../views/pbumku/skp/permohonan/DaftarSkp";
import InspeksiSkp from "../views/pbumku/skp/penugasan/InspeksiSkp";
import ReviuRekomSkp from "../views/pbumku/skp/penugasan/ReviuRekomSkp";
import ApprovalSkp from "../views/pbumku/skp/penugasan/ApprovalSkp";
import TerbitSkp from "../views/pbumku/skp/penugasan/TerbitSkp";
import TolakSkp from "../views/pbumku/skp/penugasan/TolakSkp";
import DaftarHaccp from "../views/pbumku/haccp/permohonan/DaftarHaccp";
import InspeksiHaccp from "../views/pbumku/haccp/penugasan/InspeksiHaccp";
import ReviuRekomHaccp from "../views/pbumku/haccp/penugasan/ReviuRekomHaccp";
import ApprovalHaccp from "../views/pbumku/haccp/penugasan/ApprovalHaccp";
import TerbitHaccp from "../views/pbumku/haccp/penugasan/TerbitHacpp";
import TolakHaccp from "../views/pbumku/haccp/penugasan/TolakHaccp";
import ViewEditCpibManual from "../views/pbumku/cpib/permohonan/ViewEditCpibManual";
import ViewEditCbibManual from "../views/pbumku/cbib/permohonan/ViewEditCbibManual";
import DaftarSmkhpUsFinal from "../views/penugasan/DaftarSmkhpUsFinal";

import ValSmkhp from "../views/landing_page/ValSmkhp";
import DaftarSmkhpFinalAll from "../views/penugasan/DaftarSmkhpFinalAll";
import DaftarSmkhpFinalAllTrader from "../views/permohonan/ekspor/DaftarSmkhpFinalAllTrader";

import FormPermohananView from "../views/cetak/kapal/FormPermohonanKapal";
import NotificationPage from "../views/notification/NotificationPage";
import SmkhpApprovalPage from "../views/approval/SmkhpApprovalPage";
import SignaturePage from "../views/signature/SignaturePage";
import CertificateSetupPage from "../views/signature/CertificateSetupPage";
import SignedDocumentPage from "../views/signature/SignedDocumentPage";
import SignedDocumentsPage from "../views/signature/SignedDocumentsPage";
import PendingSignaturesPage from "../views/signature/PendingSignaturesPage";
import SignatureRolloutGuard from "../components/signature/SignatureRolloutGuard";
import VerifySignaturePage from "../views/signature/VerifySignaturePage";
import AnnouncementAdmin from "../views/announcement/AnnouncementAdmin";
import AnnouncementCenter from "../views/announcement/AnnouncementCenter";

export const DefaultRouter = [
  {
    path: "/",
    element: <Default />,
    children: [
      {
        path: "dashboard",
        element: <Index />,
      },
      {
        path: "pengumuman",
        element: <AnnouncementCenter />,
      },
      {
        path: "pengumuman/:id",
        element: <AnnouncementCenter />,
      },
      {
        path: "admin/announcements",
        element: <AnnouncementAdmin />,
      },
      {
        path: "notifications",
        element: <NotificationPage />,
      },
      {
        path: "smkhp/approval/:nomorAju",
        element: <SmkhpApprovalPage />,
      },
      {
        path: "signature/certificate",
        element: <SignatureRolloutGuard><CertificateSetupPage /></SignatureRolloutGuard>,
      },
      {
        path: "signature/:documentId",
        element: <SignatureRolloutGuard><SignaturePage /></SignatureRolloutGuard>,
      },
      // Hanya menampilkan PDF yang sudah ditandatangani, jadi tidak memakai SignatureRolloutGuard:
      // dibuka juga dari SMKHP Final ALL oleh user yang bukan signer (guard akan me-redirect ke dashboard).
      {
        path: "signature/:documentId/signed",
        element: <SignedDocumentPage />,
      },
      {
        path: "signature/signed",
        element: <SignatureRolloutGuard><SignedDocumentsPage /></SignatureRolloutGuard>,
      },

      // Dashboard Detail
      {
        path: "dashboard/primer",
        element: <DashPrimer />,
      },
      {
        path: "dashboard/pasca",
        element: <DashPasca />,
      },
      {
        path: "dashboard/ekspor",
        element: <DashEkspor />
      },
      // Ekspor
      {
        path: "permohonan/ekspor/view-2",
        element: <ViewEditEkspor2 />,
      },
      {
        path: "permohonan/ekspor/draft",
        element: <Draft />,
      },
      {
        path: "permohonan/ekspor/onprocess",
        element: <OnProcess />,
      },
      {
        path: "permohonan/ekspor/siap-approve",
        element: <SiapApprove />,
      },
      {
        path: "permohonan/ekspor/disetujui",
        element: <Disetujui />,
      },
      {
        path: "permohonan/ekspor/ditolak",
        element: <Ditolak />,
      },
      {
        path: "permohonan/ekspor/daftar-smkhp-final-trader",
        element: <DaftarSmkhpFinalAllTrader />,
      },
      {
        path: "penugasan/daftar",
        element: <Daftar />,
      },
      {
        path: "penugasan/daftar-proses",
        element: <DaftarProses />,
      },
      {
        path: "penugasan/daftar-ev-admin",
        element: <DaftarEvAdmin />,
      },
      {
        path: "penugasan/daftar-ev-teknis",
        element: <DaftarEvTeknis />,
      },
      {
        path: "penugasan/daftar-terbit-draft",
        element: <DaftarTerbitDraft />,
      },
      {
        path: "signature/pending",
        element: <SignatureRolloutGuard><PendingSignaturesPage /></SignatureRolloutGuard>,
      },
      {
        path: "penugasan/daftar-setuju-draft",
        element: <DaftarSetujuDraft />,
      },
      {
        path: "penugasan/daftar-selesai",
        element: <DaftarSelesai />,
      },
      {
        path: "penugasan/daftar-pnbp-belum-dibuat",
        element: <DaftarPnbpNull />,
      },
      {
        path: "penugasan/daftar-smkhp-final-us",
        element: <DaftarSmkhpUsFinal />
      },
      {
        path: "penugasan/daftar-smkhp-final-all",
        element: <DaftarSmkhpFinalAll />
      },
      //impor
      {
        path: "permohonan/impor/draft",
        element: <DraftImpor />,
      },
      {
        path: "permohonan/impor/onprocess",
        element: <OnProcessImpor />,
      },
      {
        path: "permohonan/impor/disetujui",
        element: <DisetujuiImpor />,
      },
      {
        path: "permohonan/impor/realisasipostborder",
        element: <RealisasiPostBorder />,
      },
      //master
      {
        path: "master/ikan",
        element: <MasterIkan />,
      },
      {
        path: "master/ikan-add-edit",
        element: <MasterIkanAddEdit />,
      },
      {
        path: "master/satuanikan",
        element: <MasterIkanSatuan />,
      },
      {
        path: "master/kemasan",
        element: <Kemasan />,
      },
      {
        path: "master/bentuk",
        element: <Bentuk />,
      },
      {
        path: "master/disposisi",
        element: <Disposisi />,
      },
      {
        path: "master/hasiluji",
        element: <HasilUji />,
      },
      {
        path: "master/jenishcm",
        element: <JenisHcm />,
      },
      {
        path: "master/jeniskegiatan",
        element: <JenisKegiatan />,
      },
      {
        path: "master/jenisuji",
        element: <JenisUji />,
      },
      {
        path: "master/kecamatan",
        element: <Kecamatan />,
      },
      {
        path: "master/kesimpulan",
        element: <Kesimpulan />,
      },
      {
        path: "master/hs",
        element: <MasterHs />,
      },
      {
        path: "master/metodelab",
        element: <MetodeLab />,
      },
      {
        path: "master/negara",
        element: <Negara />,
      },
      {
        path: "master/pelabuhan",
        element: <Pelabuhan />,
      },
      {
        path: "master/tarifpnbp",
        element: <TarifPnbp />,
      },
      {
        path: "master/pelabuhan-pendaratan",
        element: <PelabuhanPendaratan />,
      },
      {
        path: "setting/user-trader",
        element: <UserTrader />,
      },

      //Master Pegawai
      {
        path: 'data/pegawai',
        element: <DataPegawai />
      },

      //pbumku
      {
        path: "pbumku/daftar-primer",
        element: <DaftarPrimer />,
      },
      {
        path: "pbumku/dokumen-checklist",
        element: <DokChecklist />,
      },
      {
        path: "pbumku/kapal/draft-kapal",
        element: <DraftKapal />
      },
      {
        path: "pbumku/kapal/onprocess-kapal",
        element: <OnProcessKapal />
      },
      {
        path: "pbumku/kapal/evp-kapal",
        element: <EvpKapal />
      },
      {
        path: "pbumku/kapal/inspeksi-kapal",
        element: <InspeksiKapal />
      },
      {
        path: "pbumku/kapal/evt-kapal",
        element: <EvtKapal />
      },
      {
        path: "pbumku/kapal/terbit-kapal",
        element: <TerbitKapal />
      },
      {
        path: "pbumku/kapal/reject-kapal",
        element: <TolakKapal />
      },
      {
        path: "pbumku/kapal/view-kapal",
        element: <ViewEditKapal />
      },
      {
        path: "pbumku/kapal/master-kapal",
        element: <MasterKapal />
      },
      {
        path: "pbumku/cpib/daftar",
        element: <DaftarCpib />
      },
      {
        path: "pbumku/cpib/daftar-manual",
        element: <DaftarCpibManual />
      },
      {
        path: "pbumku/cpib/view-cpib",
        element: <ViewEditCpibManual />
      },
      {
        path: "pbumku/cpib/evaluasi-dok",
        element: <VerifikasiDokCpib />
      },
      {
        path: "pbumku/cpib/inspeksi",
        element: <InspeksiCpib />
      },
      {
        path: "pbumku/cpib/reviu-rekom",
        element: <ReviuRekomCpib />
      },
      {
        path: "pbumku/cpib/approval",
        element: <ApprovalCpib />
      },
      {
        path: "pbumku/cpib/terbit",
        element: <TerbitCpib />
      },
      {
        path: "pbumku/cpib/tolak",
        element: <TolakCpib />
      },
      {
        path: "pbumku/cbib/daftar",
        element: <DaftarCbib />
      },
      {
        path: "pbumku/cbib/daftar-manual",
        element: <DaftarCbibManual />
      },
      {
        path: "pbumku/cbib/view-cbib",
        element: <ViewEditCbibManual />
      },
      {
        path: "pbumku/cbib/evaluasi-dok",
        element: <VerifikasiDokCbib />
      },
      {
        path: "pbumku/cbib/inspeksi",
        element: <InspeksiCbib />
      },
      {
        path: "pbumku/cbib/reviu-rekom",
        element: <ReviuRekomCbib />
      },
      {
        path: "pbumku/cbib/approval",
        element: <ApprovalCbib />
      },
      {
        path: "pbumku/cbib/terbit",
        element: <TerbitCbib />
      },
      {
        path: "pbumku/cbib/tolak",
        element: <TolakCbib />
      },
      {
        path: "pbumku/cppib/daftar",
        element: <DaftarCppib />
      },
      {
        path: "pbumku/cppib/inspeksi",
        element: <InspeksiCppib />
      },
      {
        path: "pbumku/cppib/reviu-rekom",
        element: <ReviuRekomCppib />
      },
      {
        path: "pbumku/cppib/approval",
        element: <ApprovalCppib />
      },
      {
        path: "pbumku/cppib/terbit",
        element: <TerbitCppib />
      },
      {
        path: "pbumku/cppib/tolak",
        element: <TolakCppib />
      },
      {
        path: "pbumku/cpoib/daftar",
        element: <DaftarCpoib />
      },
      {
        path: "pbumku/cpoib/inspeksi",
        element: <InspeksiCpoib />
      },
      {
        path: "pbumku/cpoib/reviu-rekom",
        element: <ReviuRekomCpoib />
      },
      {
        path: "pbumku/cpoib/approval",
        element: <ApprovalCpoib />
      },
      {
        path: "pbumku/cpoib/terbit",
        element: <TerbitCpoib />
      },
      {
        path: "pbumku/cpoib/tolak",
        element: <TolakCpoib />
      },
      {
        path: "pbumku/cdoib/daftar",
        element: <DaftarCdoib />
      },
      {
        path: "pbumku/cdoib/inspeksi",
        element: <InspeksiCdoib />
      },
      {
        path: "pbumku/cdoib/reviu-rekom",
        element: <ReviuRekomCdoib />
      },
      {
        path: "pbumku/cdoib/approval",
        element: <ApprovalCdoib />
      },
      {
        path: "pbumku/cdoib/terbit",
        element: <TerbitCdoib />
      },
      {
        path: "pbumku/cdoib/tolak",
        element: <TolakCdoib />
      },
      {
        path: "pbumku/cpibk/daftar",
        element: <DaftarCpibk />
      },
      {
        path: "pbumku/cpibk/inspeksi",
        element: <InspeksiCpibk />
      },
      {
        path: "pbumku/cpibk/reviu-rekom",
        element: <ReviuRekomCpibk />
      },
      {
        path: "pbumku/cpibk/approval",
        element: <ApprovalCpibk />
      },
      {
        path: "pbumku/cpibk/terbit",
        element: <TerbitCpibk />
      },
      {
        path: "pbumku/cpibk/tolak",
        element: <TolakCpibk />
      },
      {
        path: "pbumku/spdi/daftar",
        element: <DaftarSpdi />
      },
      {
        path: "pbumku/spdi/inspeksi",
        element: <InspeksiSpdi />
      },
      {
        path: "pbumku/spdi/reviu-rekom",
        element: <ReviuRekomSpdi />
      },
      {
        path: "pbumku/spdi/approval",
        element: <ApprovalSpdi />
      },
      {
        path: "pbumku/spdi/terbit",
        element: <TerbitSpdi />
      },
      {
        path: "pbumku/spdi/tolak",
        element: <TolakSpdi />
      },
      {
        path: "pbumku/skp/daftar",
        element: <DaftarSkp />
      },
      {
        path: "pbumku/skp/inspeksi",
        element: <InspeksiSkp />
      },
      {
        path: "pbumku/skp/reviu-rekom",
        element: <ReviuRekomSkp />
      },
      {
        path: "pbumku/skp/approval",
        element: <ApprovalSkp />
      },
      {
        path: "pbumku/skp/terbit",
        element: <TerbitSkp />
      },
      {
        path: "pbumku/skp/tolak",
        element: <TolakSkp />
      },
      {
        path: "pbumku/haccp/daftar",
        element: <DaftarHaccp />
      },
      {
        path: "pbumku/haccp/inspeksi",
        element: <InspeksiHaccp />
      },
      {
        path: "pbumku/haccp/reviu-rekom",
        element: <ReviuRekomHaccp />
      },
      {
        path: "pbumku/haccp/approval",
        element: <ApprovalHaccp />
      },
      {
        path: "pbumku/haccp/terbit",
        element: <TerbitHaccp />
      },
      {
        path: "pbumku/haccp/tolak",
        element: <TolakHaccp />
      },
      //setting
      {
        path: "setting/pengguna",
        element: <Pengguna />,
      },
      {
        path: "setting/rolepengguna",
        element: <RolePengguna />,
      },
      {
        path: "setting/upt",
        element: <Upt />,
      },
      {
        path: "setting/upi",
        element: <Upi />,
      },
      {
        path: "setting/upi-add-edit",
        element: <UpiAddEdit />,
      },
      {
        path: "setting/trader",
        element: <Traders />,
      },
      {
        path: "setting/edit-trader",
        element: <EditTRader />,
      },
      {
        path: "setting/edit-pegawai",
        element: <EditPegawai />,
      },
      {
        path: "setting/partner",
        element: <Partner />,
      },
      {
        path: "setting/partner-add-edit",
        element: <PartnerAddEdit />,
      },
      {
        path: "setting/trader-alamat",
        element: <TraderAlamat />,
      },
      {
        path: "setting/trader-alamat-add-edit",
        element: <TraderAlamatAddEdit />,
      },
      {
        path: "setting/trader-profile",
        element: <Profile />,
      },
      {
        path: "setting/supplier",
        element: <SupplierPage />,
      }, {
        path: "setting/edit-supplier",
        element: <EditUpiSupplier />,
      },
      // reporting
      {
        path: "report/report-smkhp",
        element: <ReportSMKHP />,
      },
      {
        path: "report/report-umku",
        element: <ReportUMKU />,
      },
      {
        path: "/report/report-pasca",
        element: <ReportPasca />
      },

      // nonlalin
      {
        path: "nonlalin/draft",
        element: <DraftNonLalin />,
      },
      {
        path: "nonlalin/draft-upt",
        element: <DraftNonLalinUPT />,
      },
      {
        path: "nonlalin/onprocess",
        element: <OnProcessNonLalin />,
      },
      {
        path: "nonlalin/view",
        element: <ViewEditNonLalin />,
      },
      {
        path: "nonlalin/daftar-masuk",
        element: <DaftarMasuk />,
      },
      {
        path: "nonlalin/daftar-lab",
        element: <DaftarLab />,
      },
      {
        path: "nonlalin/daftar-lainnya",
        element: <DaftarJasaLainnya />,
      },
      {
        path: "nonlalin/daftar-scanning",
        element: <DaftarScanning />,
      },

      // pnbp billing
      {
        path: "billing/daftar",
        element: <DaftarBilling />
      },
      {
        path: "billing/daftar-pnbp",
        element: <DaftarPnbp />
      },
      {
        path: "setting/edit-pnbp",
        element: <EditPnbp />
      },

      {
        path: "activate-passphrase",
        element: <ActivatePassphrase />
      }
    ],
  },
  {
    path: "login",
    element: <Login />,
  },
  {
    path: "update-password",
    element: <SignUp />,
  },
  {
    path: "registrasi",
    element: <Registrasi />,
  },

  {
    path: "view-smkhp/:noAju",
    element: <QRCode />,
  },
  {
    path: "reset-password/:token",
    element: <ResetPassword />,
  },
  {
    path: "view-smkhp/H/:noAju",
    element: <FormH />,
  },
  {
    path: "statistik",
    element: <Statistik />,
  },
  {
    path: "val-smkhp",
    element: <ValSmkhp />,
  },
  // Verifikasi TTE publik (tanpa login). Path harus sama dengan app.verification.public-base-url di ppm-be-signature.
  {
    path: "signature/verify",
    element: <VerifySignaturePage />,
  },
  {
    path: "signature/verify/:verificationCode",
    element: <VerifySignaturePage />,
  },
  {
    path: "CPIBView",
    element: <FormPermohananView />,
  },
];
